import { Component, OnInit, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';
import { MarginWrapper } from '../../layouts/margin-wrapper';

@Component({
  selector: 'allas-bajo-construccion',
  imports: [MainLayout, MarginWrapper],
  template: `
    <allas-main-layout>
      <allas-margin-wrapper>
        <main
          class="min-h-[calc(100vh-300px)] flex flex-col xl:flex-row justify-center items-center gap-12"
        >
          <img
            src="images/misc/bajo-construccion.webp"
            alt="Bajo Construcción"
            class="w-1/2 h-1/2 object-contain order-2 xl:order-1"
          />
          <div class="flex flex-col gap-2 order-1 xl:order-2">
            <h1 class="text-4xl xl:text-6xl font-bold fs-condensed">
              Página en Construcción
            </h1>
            <p class="text-sm xl:text-lg fs-condensed">
              Por el momento, no podemos ofrecer este servicio. Por favor,
              regresa más tarde.
            </p>
          </div>
        </main>
      </allas-margin-wrapper>
    </allas-main-layout>
  `,
})
export class BajoConstruccion implements OnInit {
  private title = inject(Title);
  private meta = inject(Meta);

  ngOnInit() {
    this.setMetaTags();
  }

  private setMetaTags() {
    const pageTitle = 'Página en Construcción | Allas Repuestos';
    const description =
      'Esta página está en construcción. Volveremos pronto con nuevos servicios y funcionalidades.';
    const imageUrl = 'https://www.allasrepuestos.com/logos/isotipo.webp';

    this.title.setTitle(pageTitle);

    this.meta.updateTag({
      name: 'description',
      content: description,
    });

    this.meta.updateTag({
      property: 'og:title',
      content: pageTitle,
    });

    this.meta.updateTag({
      property: 'og:description',
      content: description,
    });

    this.meta.updateTag({
      property: 'og:type',
      content: 'website',
    });

    this.meta.updateTag({
      property: 'og:image',
      content: imageUrl,
    });

    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });

    this.meta.updateTag({
      name: 'twitter:title',
      content: pageTitle,
    });

    this.meta.updateTag({
      name: 'twitter:description',
      content: description,
    });
  }
}
